<script>
    import StepsProgressBar from '../common/sidebar/StepsProgressBar.svelte'
    import AppComponent from '../common/AppComponent.svelte'
    import OrganizationsPage from "../organizations/OrganizationsPage.svelte"
    import {organizationsPageState} from './organizationsState'
</script>

<StepsProgressBar currentPage={2}/>
<AppComponent previousPage="#/registration" nextPage="#/users" nextPageEnabled={$organizationsPageState}>
    <OrganizationsPage/>
</AppComponent>
